import { EquipmentDeficiencyDocument } from '../EquipmentDeficiency/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  EquipmentDeficiencyAttachmentDocument,
  equipmentDeficiencyAttachmentPullQueryBuilder,
  equipmentDeficiencyAttachmentPushQueryBuilder,
} from './queryBuilder';

export function equipmentDeficiencyAttachmentFamilyMember(
  configBuilder: ConfigBuilder,
  equipmentDeficiency: FamilyMember<EquipmentDeficiencyDocument>,
): FamilyMember<EquipmentDeficiencyAttachmentDocument> {
  const syncConfig = configBuilder<EquipmentDeficiencyAttachmentDocument>(
    RxdbCollectionNameV2.EQUIPMENT_DEFICIENCY_ATTACHMENT,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, equipmentDeficiencyAttachmentPullQueryBuilder);
  push(syncConfig, equipmentDeficiencyAttachmentPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.EQUIPMENT_DEFICIENCY_ATTACHMENT, replicationState, [
    equipmentDeficiency,
  ]);
}
